import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import type { DealEventFindInterface } from '@zaoblako/shared/modules/business/dto/deal-event/deal.event.find.dto';
import type { DealEventRescheduleInterface } from '@zaoblako/shared/modules/business/dto/deal-event/deal.event.reschedule.dto';
import type { EventCalendarItemFindInterface } from '@zaoblako/shared/modules/report/dtos/event-calendar/event-calendar-item-find.dto';
import { DealEventService } from '@zaoblako/web/core/services/deal/deal-event.service';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { DealEventRescheduleFormComponent } from '@zaoblako/web/modules/deal/dumbs/deal-event-reschedule-form/deal-event-reschedule-form.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'crm-deal-event-reschedule',
  standalone: true,
  imports: [CommonModule, SpinnerComponent, DealEventRescheduleFormComponent],
  templateUrl: './deal-event-reschedule.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DealEventRescheduleComponent {
  public dealEventId: number;
  public dealId: number;
  public saving = false;

  public dealEvent = <DealEventRescheduleInterface>{};
  public event: DealEventFindInterface;

  public constructor(
    private readonly dealEventService: DealEventService,
    private readonly errorService: ErrorService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig
  ) {
    this.dealEventId = this.config.data?.dealEventId;
    this.dealId = this.config.data?.dealId;

    this.event = this.config.data?.event;
    if (this.event) {
      this.dealEvent.startAt = this.event.startAt;
      this.dealEvent.endAt = this.event.endAt;
    }

    const eventCalendar: EventCalendarItemFindInterface = this.config.data?.eventCalendar;
    if (eventCalendar) {
      this.dealEvent.startAt = eventCalendar.date;
      this.dealEvent.endAt = eventCalendar.endDate;
    }
  }

  public save(event: DealEventRescheduleInterface) {
    this.saving = true;
    this.cdRef.markForCheck();

    this.dealEventService.rescheduleOne(this.dealId, this.dealEventId, event).subscribe({
      next: (event) => {
        this.saving = false;
        this.cdRef.markForCheck();
        this.errorService.addSuccessMessage('Событие перенесено');
        this.ref.close(event);
      },
      error: () => {
        this.saving = false;
        this.cdRef.markForCheck();
      }
    });
  }
}
